function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  d: "M31.357 33.887a6.562 6.562 0 1 0 13.124 0 6.562 6.562 0 0 0-13.124 0",
  fill: "#BEFFFC"
}), React.createElement("path", {
  d: "M24.65 33.887c0 8.346 6.766 15.112 15.112 15.112s15.112-6.766 15.112-15.112-6.766-15.112-15.112-15.112S24.65 25.54 24.65 33.887z",
  stroke: "#28348A",
  strokeWidth: 0.4
}), React.createElement("path", {
  d: "M33.2 33.887a6.562 6.562 0 1 0 13.124 0 6.562 6.562 0 0 0-13.124 0zM1.949 8.468L39.994 34.45M6.986 11.915L.358 15.229l9.147 6.363 6.677-3.38m-9.16-6.303l.754-7.372 9.188 6.303-.754 7.372m33.163 4.043l10.837-9.842m11.533-5.27a6.959 6.959 0 0 0-6.96-6.96 6.958 6.958 0 0 0-6.96 6.96 6.958 6.958 0 0 0 6.96 6.959 6.959 6.959 0 0 0 6.96-6.96zm11.284 26.694a6.96 6.96 0 1 0-13.92.001 6.96 6.96 0 0 0 13.92 0zM46.688 69.728a6.958 6.958 0 0 0-6.959-6.959 6.958 6.958 0 0 0-6.959 6.96 6.958 6.958 0 0 0 6.959 6.958 6.958 6.958 0 0 0 6.959-6.959zm8.186-35.841h14.185M39.762 49v13.67",
  stroke: "#28348A",
  strokeWidth: 0.4
}));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 83 77",
    width: "1em",
    height: "1em"
  }, props), _ref);
};

export default SvgComponent;


// WEBPACK FOOTER //
// ./src/components/sections/aboutUs/ecoSystem/segmentation.svg